__turbopack_context__.v({
  "accordion-root": "AccordionSection-module-scss-module__Dl8LDa__accordion-root",
  "body": "AccordionSection-module-scss-module__Dl8LDa__body",
  "content": "AccordionSection-module-scss-module__Dl8LDa__content",
  "heading": "AccordionSection-module-scss-module__Dl8LDa__heading",
  "icon": "AccordionSection-module-scss-module__Dl8LDa__icon",
  "item": "AccordionSection-module-scss-module__Dl8LDa__item",
  "pdf": "AccordionSection-module-scss-module__Dl8LDa__pdf",
  "slide-down": "AccordionSection-module-scss-module__Dl8LDa__slide-down",
  "slide-up": "AccordionSection-module-scss-module__Dl8LDa__slide-up",
  "trigger": "AccordionSection-module-scss-module__Dl8LDa__trigger",
});
